<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("consentConfig")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card d-flex flex-column px-4" style="margin-top: 1rem">
        <div class="mb-4"
          style="margin-top: 1rem; border-radius: 16px; background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);">
          <div class="pa-6">
            <v-row align="center" justify="space-between">
              <v-col cols="auto">
                <h3 class="text-h6 font-weight-medium text-primary">
                  <v-icon class="mr-2" color="primary">mdi-cog-outline</v-icon>
                  Configuration Panel
                </h3>
              </v-col>
            </v-row>

            <v-row align="center" class="control-row">
              <!-- Version Display -->
              <v-col cols="12" sm="6" md="3">
                <v-card flat class="version-card pa-4"
                  style="background: rgba(25, 118, 210, 0.05); border: 1px solid rgba(25, 118, 210, 0.1); border-radius: 12px;">
                  <div class="d-flex align-center">
                    <v-avatar size="32" color="primary" class="mr-3">
                      <v-icon color="white" size="16">mdi-tag</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption text-grey-darken-1 mb-1">Current Version</div>
                      <div class="text-subtitle-1 font-weight-medium text-primary">{{ version || 'N/A' }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <!-- Version Selector -->
              <v-col cols="12" sm="6" md="5">
                <v-autocomplete v-model="viewVersion" :items="listViewVersion" item-title="showVersion" item-value="id"
                  label="View Previous Version" placeholder="Select version to preview" variant="outlined"
                  density="comfortable" clearable hide-details prepend-inner-icon="mdi-history" color="primary"
                  class="modern-select" style="border-radius: 12px;">
                  <template v-slot:selection="{ item }">
                    <v-chip color="primary" variant="tonal" size="large" class="ma-1">
                      <template v-slot:prepend>
                        <v-icon size="16" class="mr-2">mdi-tag-outline</v-icon>
                      </template>
                      {{ item.title }}
                    </v-chip>
                  </template>

                  <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" :title="item.raw.showVersion" class="pa-3">
                      <template v-slot:prepend>
                        <v-avatar size="32" color="primary" variant="tonal">
                          <v-icon size="16">mdi-tag-outline</v-icon>
                        </v-avatar>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>

              <!-- Save Button -->
              <v-col v-if="!isViewOnly" cols="12" sm="12" md="4" class="d-flex justify-end">
                <v-btn id="button-updateconsent-consentconfig" color="success" variant="elevated" size="large"
                  class="save-btn px-8" style="border-radius: 12px; text-transform: none; font-weight: 600;"
                  @click="updateConsent()">
                  <v-icon start size="20">mdi-content-save</v-icon>
                  {{ $t('save') }}
                </v-btn>
              </v-col>
            </v-row>

            <!-- Progress indicator (optional) -->
            <v-expand-transition>
              <v-card v-if="savingIndicator" flat class="mt-4 pa-3"
                style="background: rgba(76, 175, 80, 0.1); border-radius: 8px;">
                <div class="d-flex align-center">
                  <v-progress-circular indeterminate size="20" width="2" color="success"
                    class="mr-3"></v-progress-circular>
                  <span class="text-caption text-success">Saving changes...</span>
                </div>
              </v-card>
            </v-expand-transition>
          </div>
        </div>
        <v-row class="d-flex flex-grow-1 pb-8">
          <v-col cols="6" class="d-flex">
            <v-card outlined class="flex-grow-1 d-flex flex-column">
              <v-card-title style="font-size: 16px;">Consent(TH)</v-card-title>
              <v-card-text class="flex-grow-1 d-flex pa-0">
                <EditorJS v-model:content="dataConsentTH" class="flex-grow-1" style="overflow-y: auto; height: 100%;" />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" class="d-flex">
            <v-card outlined class="flex-grow-1 d-flex flex-column">
              <v-card-title style="font-size: 16px;">Consent(EN)</v-card-title>
              <v-card-text class="flex-grow-1 d-flex pa-0">
                <EditorJS v-model:content="dataConsentEN" class="flex-grow-1" style="overflow-y: auto; height: 100%;" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

    </v-container>
    <v-dialog v-model="viewVersion_dialog" max-width="1080px">
      <v-card>
        <v-card-title>
          <p style="color: #1d4f81">{{ $t('gpt_model_management_version_history_detail') }}</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="d-flex">
              <v-col cols="12" sm="6" md="6">
                <v-card outlined>
                  <v-card-title style="font-size: 16px;">Consent(TH)</v-card-title>
                  <v-card-text>
                    <div v-html="viewVersion_consentTH" style="overflow-y: auto; height: 40dvh;"
                      class="no-border-editor data-consent-text"></div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-card outlined>
                  <v-card-title style="font-size: 16px;">Consent(EN)</v-card-title>
                  <v-card-text>
                    <div v-html="viewVersion_consentEN" style="overflow-y: auto; height: 40dvh;"
                      class="no-border-editor data-consent-text"></div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeViewVersion()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EditorJS from '@/components/EditorJS.vue';
import LogTrace from '@/api/function.js';
// ที่นี่คุณสามารถ import plugins ของ EditorJS ที่ต้องการใช้งาน เช่น:
// import Header from '@editorjs/header';
// import List from '@editorjs/list';
// import Paragraph from '@editorjs/paragraph';

export default {
  name: "ConsentConfig",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [LogTrace],
  components: { EditorJS },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ConsentConfig');
    },
  },
  data: () => ({
    today: null,
    viewVersion_dialog: false,
    dataConsentTH: "",
    dataConsentEN: "",
    version: "",
    listViewVersion: [],
    viewVersion: null,
    id: null,
    viewVersion_consentTH: "",
    viewVersion_consentEN: "",
    editorTH: null,
    editorEN: null,
    viewEditorTH: null,
    viewEditorEN: null,
    savingIndicator: false,
    editorConfig: {
      holder: '',
      placeholder: 'เริ่มพิมพ์ข้อความที่นี่...',
      tools: {
        // ตัวอย่างการประกาศ plugins (คุณต้องติดตั้งพวกนี้เพิ่มเติม)
        /*
        header: {
          class: Header,
          inlineToolbar: ['link'],
          config: {
            placeholder: 'หัวข้อ'
          },
          shortcut: 'CMD+SHIFT+H'
        },
        paragraph: {
          class: Paragraph,
          inlineToolbar: true
        },
        list: {
          class: List,
          inlineToolbar: true
        }
        */
      },
      data: {
        blocks: []
      }
    },
    editorConfigView: {
      holder: '',
      readOnly: true,
      tools: {}
    }
  }),
  watch: {
    // viewVersion(value) {
    //     if(value) {
    //         this.viewVersion_dialog = true;
    //     }
    // },
    viewVersion(newId) {
      if (newId) {
        this.changeVersion(newId);
        this.viewVersion_dialog = true;
      }
    },
  },
  methods: {
    Get() {
      let self = this;
      self.$call.GetConsentConfig(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dataConsentTH = dataResponse.data.consentTH;
            self.dataConsentEN = dataResponse.data.consentEN;
            self.version = dataResponse.data.showVersion;
          }
          else {
            self.dataConsentTH = "";
            self.dataConsentEN = "";
            self.version = ""
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );

    },
    getViewVersion() {
      let self = this;
      self.$call.GetViewVersion(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listViewVersion = dataResponse.data;
          }
          else {
            self.listViewVersion = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );

    },
    updateConsent() {
      let self = this;
      try {
        if (self.dataConsentTH == "" || self.dataConsentEN == "") {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningFillAll'),
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
        this.savingIndicator = true;
        let temp = {
          ConsentTH: self.dataConsentTH,
          ConsentEN: self.dataConsentEN,
          Version: self.version,
        };

        self.$call.UpdateConsent(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1800,
                backdrop: false 
              });
              self.Get();
              self.getViewVersion();
              this.savingIndicator = false;
            }
          },
          (errorResource) => {
            this.savingIndicator = false;
            console.error(errorResource);
          }
        );
      } catch (error) {

        this.savingIndicator = false;
        self.LogTrace(error, 'Update');
      }
    },
    closeViewVersion() {
      let self = this;
      self.viewVersion_dialog = false;
      self.viewVersion = null;
      self.viewVersion_consentTH = "";
      self.viewVersion_consentEN = "";
    },
    changeVersion(id) {
      let self = this;
      let temp = {
        ID: id,
      };
      self.$call.GetConsentById(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            console.log(dataResponse.data);
            self.viewVersion_consentTH = dataResponse.data.consentTH;
            self.viewVersion_consentEN = dataResponse.data.consentEN;
          }
          else {
            self.viewVersion_consentTH = "";
            self.viewVersion_consentEN = "";
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      )
    },
    formatText(text) {
      return text
        .replace(/\n/g, '<br>')
        .replace(/\t/g, '&emsp;')
        .replace(/ {2} /g, '&nbsp;&nbsp;');
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
  },
  mounted() {
    let self = this;
    this.GetDate();
    self.Get();
    self.getViewVersion();
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin: 2rem;
}

.card-1 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 125px;
  flex-shrink: 0;
}

.formatted-text {
  white-space: pre-wrap;
}

.no-border-editor .ce-block__content,
.no-border-editor .ce-toolbar__content {
  border: none !important;
  box-shadow: none !important;
}

.no-border-editor .codex-editor {
  border: none !important;
}

.version-card {
  transition: all 0.2s ease-in-out;
}

.version-card:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.modern-select {
  transition: all 0.2s ease-in-out;
}

.modern-select:hover {
  transform: translateY(-1px);
}

.control-row {
  position: relative;
}

.control-row::before {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.1) 50%, transparent 100%);
}

/* Animation for autocomplete */
.v-autocomplete .v-field__input {
  transition: all 0.2s ease-in-out;
}

.v-autocomplete:focus-within .v-field__input {
  transform: translateX(4px);
}

/* Responsive improvements */
@media (max-width: 960px) {

  .save-btn {
    width: 100%;
    margin-top: 1rem;
  }
}

@media (max-width: 600px) {
  .version-card {
    margin-bottom: 1rem;
  }
}
</style>